export const platformFilterOptions = [
  { value: 0, label: 'All Types' },
  { value: 1, label: 'Xero Accounting' },
  { value: 2, label: 'Xero Practice Manager' },
  { value: 5, label: 'WorkGuru' },
  { value: 6, label: 'BlueRock Workflow Max' },
  { value: 7, label: 'Karbon' },
  { value: 8, label: 'FYI' },
  { value: 4, label: 'MYOB' },
  { value: 9, label: 'QuickBooks' },
]

export function platformTypeLabelFromTypeId(typeId: number): string {
  const opt = platformFilterOptions.find((o) => o.value === typeId)
  return opt?.label ?? 'Unknown'
}

export const refreshStatusColumnHelp =
  'Pending: Awaiting authentication or first sync\nRefreshing: Data refresh in progress\nRefreshed: Last refresh completed successfully\nFailed: Last refresh attempt failed\nConnected: Organisation is connected'
